import type { ReactNode } from "react";
import { useGameStore } from "../store/useGameStore";
import { PlayerHeaderBar } from "./PlayerHeaderBar";
import { ChatPanel } from "./ChatPanel";
import type { Screen } from "../types";
import clsx from "clsx";

const NAV_ITEMS: { id: Screen; icon: string; label: string }[] = [
  { id: "main", icon: "🏰", label: "Home" },
  { id: "battle", icon: "⚔️", label: "Battle" },
  { id: "top", icon: "🏆", label: "Top" },
  { id: "hero", icon: "🦸", label: "Hero" },
  { id: "inventory", icon: "🎒", label: "Bag" },
  { id: "shop", icon: "🛒", label: "Shop" },
];

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { activeScreen, setScreen } = useGameStore();

  return (
    <div className="app-shell flex flex-col h-screen bg-kingdom-dark text-white overflow-hidden">
      <PlayerHeaderBar />

      {/* Main content */}
      <div className="layout-main flex-1 min-h-0 overflow-y-auto">{children}</div>

      <ChatPanel />

      {/* Bottom nav */}
      <nav className="relative z-10 bg-kingdom-purple border-t border-kingdom-mid safe-bottom shrink-0">
        <div className="flex justify-around py-1">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              onClick={() => setScreen(item.id)}
              className={clsx(
                "flex flex-col items-center py-1.5 px-1.5 rounded-lg transition-all min-w-0",
                activeScreen === item.id ||
                  (item.id === "battle" &&
                    (activeScreen === "campaignRun" ||
                      activeScreen === "campaign" ||
                      activeScreen === "mpDungeons" ||
                      activeScreen === "mpDungeonRun"))
                  ? "text-kingdom-glow bg-kingdom-mid"
                  : "text-gray-500 hover:text-gray-300",
              )}
            >
              <span className="text-lg">{item.icon}</span>
              <span className="text-[9px] mt-0.5 font-medium whitespace-nowrap">{item.label}</span>
            </button>
          ))}
        </div>
      </nav>
    </div>
  );
}
